import type { MapData } from '@/types/map-data';
import type { TileType } from '@/types/map-data';

// Shorthand aliases for readability
const W: TileType = 'wall';
const D: TileType = 'dot';
const P: TileType = 'power_pill';
const E: TileType = 'empty';
const T: TileType = 'tunnel';
const G: TileType = 'ghost_base';
const S: TileType = 'spawn_point';
const F: TileType = 'fruit_spawn';

// Arena: More open spaces with islands of walls, feels spacious
// 28 wide x 31 tall
const tiles: ReadonlyArray<ReadonlyArray<TileType>> = [
  // Row 0: top border
  [W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W],
  // Row 1
  [W,D,D,D,D,D,D,D,D,D,D,D,D,W,W,D,D,D,D,D,D,D,D,D,D,D,D,W],
  // Row 2
  [W,D,W,W,D,W,W,D,W,W,W,W,D,D,D,D,W,W,W,W,D,W,W,D,W,W,D,W],
  // Row 3: power pills
  [W,P,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,D,P,W],
  // Row 4
  [W,D,W,W,D,D,W,W,D,W,D,D,D,W,W,D,D,D,W,D,W,W,D,D,W,W,D,W],
  // Row 5
  [W,D,D,D,D,D,D,D,D,W,D,D,D,D,D,D,D,D,W,D,D,D,D,D,D,D,D,W],
  // Row 6
  [W,D,W,D,W,W,D,W,D,D,D,W,W,D,D,W,W,D,D,D,W,D,W,W,D,W,D,W],
  // Row 7
  [W,D,W,D,D,D,D,W,D,D,D,D,D,D,D,D,D,D,D,D,W,D,D,D,D,W,D,W],
  // Row 8
  [W,D,D,D,W,W,D,D,D,W,W,D,D,D,D,D,D,W,W,D,D,D,W,W,D,D,D,W],
  // Row 9
  [W,W,W,D,W,W,D,W,D,W,W,W,D,W,W,D,W,W,W,D,W,D,W,W,D,W,W,W],
  // Row 10
  [E,E,E,D,D,D,D,W,D,D,D,D,D,W,W,D,D,D,D,D,W,D,D,D,D,E,E,E],
  // Row 11
  [E,E,E,D,W,W,D,D,D,D,E,E,E,E,E,E,E,E,D,D,D,D,W,W,D,E,E,E],
  // Row 12: ghost base top
  [E,E,E,D,W,W,D,W,W,E,W,W,W,G,G,W,W,W,E,W,W,D,W,W,D,E,E,E],
  // Row 13: ghost base entrance
  [W,W,W,D,D,D,D,D,W,E,W,G,G,G,G,G,G,W,E,W,D,D,D,D,D,W,W,W],
  // Row 14: tunnel row + ghost base interior
  [T,E,E,D,W,W,D,D,E,E,W,G,G,G,G,G,G,W,E,E,D,D,W,W,D,E,E,T],
  // Row 15: ghost base bottom area
  [W,W,W,D,W,W,D,D,W,E,W,G,G,G,G,G,G,W,E,W,D,D,W,W,D,W,W,W],
  // Row 16: ghost base bottom wall
  [E,E,E,D,D,D,D,W,W,E,W,W,W,W,W,W,W,W,E,W,W,D,D,D,D,E,E,E],
  // Row 17: fruit spawn row
  [E,E,E,D,W,W,D,D,D,E,E,E,E,F,E,E,E,E,E,D,D,D,W,W,D,E,E,E],
  // Row 18
  [E,E,E,D,W,W,D,W,D,D,W,W,W,D,D,W,W,W,D,D,W,D,W,W,D,E,E,E],
  // Row 19
  [W,W,W,D,D,D,D,W,D,D,D,D,D,D,D,D,D,D,D,D,W,D,D,D,D,W,W,W],
  // Row 20
  [W,D,D,D,W,W,D,D,D,W,W,D,D,D,D,D,D,W,W,D,D,D,W,W,D,D,D,W],
  // Row 21
  [W,D,W,D,D,D,D,D,D,D,D,D,W,D,D,W,D,D,D,D,D,D,D,D,D,W,D,W],
  // Row 22
  [W,D,W,D,W,W,D,W,D,D,D,D,W,D,D,W,D,D,D,D,W,D,W,W,D,W,D,W],
  // Row 23: Pac-Man spawn
  [W,D,D,D,D,D,D,W,D,W,D,D,D,S,E,D,D,D,W,D,W,D,D,D,D,D,D,W],
  // Row 24
  [W,D,W,W,D,D,D,D,D,W,D,W,W,W,W,W,W,D,W,D,D,D,D,D,W,W,D,W],
  // Row 25
  [W,D,D,D,D,W,W,D,D,D,D,D,D,D,D,D,D,D,D,D,D,W,W,D,D,D,D,W],
  // Row 26
  [W,D,W,W,D,D,D,D,W,W,D,D,D,W,W,D,D,D,W,W,D,D,D,D,W,W,D,W],
  // Row 27: power pills bottom
  [W,P,W,W,D,W,W,D,D,D,D,W,D,D,D,D,W,D,D,D,D,W,W,D,W,W,P,W],
  // Row 28
  [W,D,D,D,D,D,D,D,W,W,D,D,D,W,W,D,D,D,W,W,D,D,D,D,D,D,D,W],
  // Row 29
  [W,D,W,W,W,W,W,D,D,D,D,D,D,D,D,D,D,D,D,D,D,W,W,W,W,W,D,W],
  // Row 30: bottom border
  [W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W,W],
];

export const MAP_ARENA: MapData = {
  id: 'arena',
  name: 'Arena',
  width: 28,
  height: 31,
  tiles,
  speedMultiplier: 1.1,
  ghostReleasePoint: { x: 13, y: 12 },
  pacmanSpawn: { x: 13, y: 23 },
  tunnelPairs: [
    {
      entry: { x: 0, y: 14 },
      exit: { x: 27, y: 14 },
    },
  ],
  fruitSpawn: { x: 13, y: 17 },
};
